export default __webpack_public_path__ + "c036d6258309f6e2f6ffb84b9a916f2b.png";